import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllVehicleGroups = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/vehicle-groups',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveVehicleGroup = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/vehicle-groups',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateVehicleGroup = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/vehicle-groups/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteVehicleGroup = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/vehicle-groups/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllVehicleGroups,
  saveVehicleGroup,
  deleteVehicleGroup,
  updateVehicleGroup,
}
